import { axios } from '@/utils/request'

const api = {
    getFentuAccount: '/5ddfb0df90e64'
}

export default {
    // 创建粉兔账户
    getFentuAccount() {
        const parameter = {}
        return axios({
            url: api.getFentuAccount,
            method: 'get',
            params: parameter
        })
    },
}
